import Vue from "vue";

import { defineStore } from "pinia";
import { usePageStore } from "@/stores/pageHeader";
import { postData } from "@utils";
import { useToast } from "vue-toastification/composition";
import { ref, computed } from "vue-demi";

export const useUserStore = defineStore("user", () => {
  const toast = useToast();
  const pageStore = usePageStore();

  // Listeleme
  const listDisabled = ref(true);
  const tableLoading = ref(false);
  const tableItems = ref([]);
  const dialogLoading = ref(false);
  const editedIndex = ref(-1);
  const editedItem = ref({
    aktif: true,
    cari_kod: "",
    mail: "",
    telnum: "",
    adrnums: "",
    ad: "",
    soyad: "",
    username: "",
    address: "",
    sifre: "",
    sifret: "",
    mail_check: 1,
    sifre_check: 1,
    cashform_branch_name: "",
    cashform_account: "",
  });

  const defaultItem = JSON.parse(JSON.stringify(editedItem.value));

  const profileList = ref([]);
  const profileFetch = async () => {
    try {
      const data = await postData({
        method: "getProfileList",
      });
      profileList.value = data.detail.map((item) => {
        return {
          value: item.profile_id,
          text: item.profile_name,
        };
      });
    } catch (e) {
      // API hataya girdi
      toast.error(`Hata ${e}`);
    }
  };

  const tableFetch = async () => {
    listDisabled.value = true;
    tableLoading.value = true;
    try {
      const data = await postData({
        method: "getMembers",
      });

      if (profileList.value.length === 0) {
        await profileFetch();
      }

      tableItems.value = data.response.result.map((item) => {
        return {
          uid: item.uid,
          aktif: item.aktif,
          member_profile: item.member_profile,
          address: item.address?.address ? item.address.address : null,
          member_Txt:
            profileList.value.find((el) => el.value === item.member_profile)?.text || "Tanımsız",
          username: item.username,
          name1: item.name1,
          cari_kod: item.cari_kod,
          telnum: item.telnum,
          mail: item.mail || "tanimsiz@asli.com.tr",
          esmroute: item.esmroute,
          esmrouteseq: item.esmrouteseq,
          emailcc: item.emailcc,
          emailto: item.emailto,
          emailbcc: item.emailbcc,
          ad: item.ad,
          soyad: item.soyad,
          son_giris: item.son_giris,
          adrnums: item.adrnums,
          cashform_branch_name: item.cashform_branch_name,
          cashform_account: item.cashform_account,
        };
      });
      pageStore.downloadData = tableItems.value;
      return [data, null];
    } catch (e) {
      // API hataya girdi
      toast.error(`Hata ${e}`);

      return [null, true];
    } finally {
      tableLoading.value = false;
      listDisabled.value = false;
    }
  };

  // Ekle / Düzenle / Sil
  const addEditdialog = ref(false);
  const deleteLoading = ref(false);
  const saveLoading = ref(false);
  const addEditFormTitle = computed(() => {
    return editedIndex.value === -1 ? "Kullanıcı Ekle" : "Düzenleme";
  });

  const editItem = (item) => {
    editedIndex.value = tableItems.value.indexOf(item);
    editedItem.value = Object.assign({}, item);
    addEditdialog.value = true;
  };

  const saveItem = async (isValid, messages = []) => {
    // Form Kontrol
    if (!isValid) {
      toast.error(
        ["Lütfen kırmızı alanları doldurun", ...messages].join("\n"),
        { position: "bottom-center" }
      );

      return;
    }
    dialogLoading.value = true;

    delete editedItem.value.name1;
    delete editedItem.value.esmroute;
    delete editedItem.value.esmrouteseq;
    delete editedItem.value.son_giris;
    delete editedItem.value.member_Txt;

    try {
      saveLoading.value = true;
      if (editedIndex.value > -1) {
        if (editedItem.value.sifre) {
          editedItem.value.sifret = editedItem.value.sifre;
          editedItem.value.sifre_check = 1;
        }
        editedItem.value.mode2 = "memberUpdate";

        const response = await postData({
          method: "insertMember",
          ...editedItem.value,
        });
        if (response.error) {
          throw new Error(response.msg);
        }

        toast.info(`"${editedItem.value.username}" Kullanıcısı güncellendi`);
      } else {
        editedItem.value.sifret = editedItem.value.sifre;
        editedItem.value.member_profile = "COMUSR";

        const response = await postData({
          method: "insertMember",
          ...editedItem.value,
        });
        if (response.error) {
          throw new Error(response.msg);
        }

        toast.success(`"${editedItem.value.username}" Kullanıcısı eklendi`);
      }

      tableFetch();
    } catch (e) {
      toast.error(`Hata ${e}`, { position: "bottom-center" });
      return;
    } finally {
      closeItem();
    }
  };

  const deleteItem = async () => {
    Vue.swal({
      title: "Emin misin",
      html: `<strong>"${editedItem.value.username}"</strong><br>kullanıcı silinsin mi`,
      icon: "warning",
      width: "350px",
      background: "#FF4C51",
      showCancelButton: true,
      confirmButtonColor: "#cc3d41",
      confirmButtonText: "Evet",
      cancelButtonText: "Vazgeç",
      cancelButtonColor: "#FF4C51",
    }).then(async (result) => {
      if (result.isConfirmed) {
        dialogLoading.value = true;
        deleteLoading.value = true;
        try {
          const response = await postData({
            method: "deleteMember",
            id: editedItem.value.uid,
          });
          if (response.error) {
            throw new Error(response.msg);
          }
          toast.warning(`"${editedItem.value.username}" kullanıcı silindi`);
          tableFetch();
        } catch (e) {
          toast.error(`Hata ${e}`, { position: "bottom-center" });
        } finally {
          closeItem();
        }
      }
    });
  };

  const closeItem = () => {
    dialogLoading.value = false;
    deleteLoading.value = false;
    saveLoading.value = false;
    addEditdialog.value = false;
    editedItem.value = Object.assign({}, defaultItem);
    editedIndex.value = -1;
  };

  return {
    // Units
    profileList,

    // Listeleme
    listDisabled,
    tableLoading,
    tableItems,
    tableFetch,
    editedItem,
    editedIndex,

    // Ürün Ekle / Düzenle / Sil
    dialogLoading,
    deleteLoading,
    saveLoading,
    addEditFormTitle,
    addEditdialog,
    editItem,
    deleteItem,
    closeItem,
    saveItem,
  };
});
